import msaConfig from './identityProviderConfig/msaConfig';
import msaIntConfig from './identityProviderConfig/msaIntConfig';
import teamSnapConfig from './identityProviderConfig/teamSnapConfig';
import googleConfig from './identityProviderConfig/googleConfig';
import { OAuthProviderType } from '../contracts/SharedProperties';
import type { HelloJSServiceDef } from 'hellojs';
import { assertNever } from 'owa-assert';

interface ServiceConfig extends HelloJSServiceDef {
    id: string;
}

type IdentityProviderConfig = { [id: string]: ServiceConfig };

export default function getIdpConfig(
    provider: OAuthProviderType,
    clientId: string
): IdentityProviderConfig {
    switch (provider) {
        case OAuthProviderType.Msa:
            return { [OAuthProviderType.Msa]: { ...msaConfig, id: clientId } };
        case OAuthProviderType.TeamSnap:
            return { [OAuthProviderType.TeamSnap]: { ...teamSnapConfig, id: clientId } };
        case OAuthProviderType.MsaInt:
            return { [OAuthProviderType.MsaInt]: { ...msaIntConfig, id: clientId } };
        case OAuthProviderType.Google:
            return { [OAuthProviderType.Google]: { ...googleConfig, id: clientId } };
        case OAuthProviderType.ICloud:
            return {};
        default:
            return assertNever(provider);
    }
}
